export const INTERESTS = [
  'Microcontrollers & IoT',
  'Operating Systems & Shell Scripting',
  'Renewable Energy',
  'Radio & Wireless Communication',
  'Embedded Systems',
];
